<template>

  <van-tabs v-model:active="active" @click-tab="onClickTab"  type="card" swipeable style="height: 100%;">
      <van-tab title="data"><business-data style="margin-top: 0.5rem;"/></van-tab>
      <van-tab title="award" style="height: 100%;"><RewardApplyData/></van-tab>
      <van-tab title="audioImport"><AudioImport/></van-tab>
    </van-tabs>




</template>
  
  <script setup >

import BusinessData from '@/components/BusinessData.vue';

import RewardApplyData from '@/components/RewardApplyData.vue';

import AudioImport from '@/components/AudioLearnDataSave.vue';


// import { useRouter } from 'vue-router';
// import { jingxinAdminLogin } from '@/api/apiService'; // 你自己的上传地址获取方法

// import { showToast } from 'vant';

  // const router = useRouter();
  import { ref } from 'vue';


  // const username = ref('user');



    // const password = ref('');


    const active = ref(0);
    const onClickTab = ({ title }) => {
      console.log(title);
    };
   
 


  




  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    
    
  }

  






  </style>